export default "__VITE_ASSET__Dsh5FJZW__"